import { Pipe, PipeTransform } from '@angular/core';
import { UserCreateTemplateType } from '../models/user.models';

@Pipe({
  name: 'userTemplate',
})
export class UserTemplatePipe implements PipeTransform {
  transform(userTemplate: UserCreateTemplateType): string {
    const dict: Record<UserCreateTemplateType, string> = {
      [UserCreateTemplateType.ProjectManager]: 'Project manager',
      [UserCreateTemplateType.NetworkDevelopment]: 'Network development',
      [UserCreateTemplateType.Client]: 'Client',
      [UserCreateTemplateType.Expert]: 'Expert',
      [UserCreateTemplateType.ServiceProvider]: 'Service provider',
      [UserCreateTemplateType.System]: 'System',
    };

    return dict[userTemplate] || '';
  }
}
